const actionTypes = require('constants/actionTypes');
const signaturePatternActions = require('actions/signaturePattern');
const { APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');

// @ consntans
const {
    BROKER_TRANSFER_VALUES_TYPE_TOTAL,
    BROKER_TRANSFER_VALUES_TYPE_PARTIAL,
    BROKER_NO_STOCKS_ACCOUNT_SELECTED
} = require('constants/index');

const reset = () => ({ type: actionTypes.BROKER_TRANSFER_VALUES_RESET });

const setType = (type) => ({
    type: actionTypes.BROKER_TRANSFER_VALUES_SET_TYPE,
    payload: {
        type
    }
});

const setAccountFrom = accountId => ({
    type: actionTypes.BROKER_TRANSFER_VALUES_SET_ACCOUNT_FROM,
    payload: {
        accountId
    }
});

const setAccountTo = accountId => ({
    type: actionTypes.BROKER_TRANSFER_VALUES_SET_ACCOUNT_TO,
    payload: {
        accountId
    }
});

const setAccountsFromOptions = accountsOptions => ({
    type: actionTypes.BROKER_TRANSFER_VALUES_SET_ACCOUNTS_FROM_OPTIONS,
    payload: {
        accountsOptions
    }
});



const setAccountsToOptions = accountsOptions => ({
    type: actionTypes.BROKER_TRANSFER_VALUES_SET_ACCOUNTS_TO_OPTIONS,
    payload: {
        accountsOptions
    }
});

const setVisibleStep = step => ({
    type: actionTypes.BROKER_TRANSFER_VALUES_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const validateStepAction = (step, validContract) => {
    return {
        type: actionTypes.BROKER_TRANSFER_VALUES_VALIDATE_STEP,
        payload: {
            step,
            validContracts: validContract
        }
    }
}

const resetContractErrors = () => {
    return {
        type: actionTypes.BROKER_TRANSFER_VALUES_RESET_CONTRACTS_ERRORS
    }
};

const transferValuesFailure = () => ({
    type: actionTypes.BROKER_TRANSFER_VALUES_FAILURE,
});

const transferValuesRequest = () => ({ type: actionTypes.BROKER_TRANSFER_VALUES_REQUEST });

const validateStep = (step) => (dispatch, getState) => {
    if (step === 1) {
        const immTransferValues = getState().brokerTransferValues;
        const immStocksContracts = getState().brokerStocksContract;

        const contractFrom = immTransferValues.getIn(['steps', 0, 'accountIdFrom']);
        const contractTo = immTransferValues.getIn(['steps', 0, 'accountIdTo']);

        if (contractFrom === BROKER_NO_STOCKS_ACCOUNT_SELECTED || contractTo === BROKER_NO_STOCKS_ACCOUNT_SELECTED) {
            return dispatch(validateStepAction(step, false));
        }

        const immContractFrom = immTransferValues.getIn(['steps', 0, 'accountsFromOptions', contractFrom]);

        const walletNumber = immContractFrom.get('walletNumber');

        const immStockContract = immStocksContracts.find(
            value => {
                return value.get('walletNumber') === walletNumber;
            }
        );

        dispatch(transferValuesRequest()); //just for backward compatibility

        if (immStockContract) {
            dispatch(validateStepAction(step, immStockContract));
        }
        else {
            dispatch(transferValuesFailure());
        }
    }
    dispatch(validateStepAction(step, true));
};

const setWillCancel = willCancel => ({
    type: actionTypes.BROKER_TRANSFER_VALUES_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const transferValuesSuccess = response => ({
    type: actionTypes.BROKER_TRANSFER_VALUES_SUCCESS,
    payload: {
        response
    }
});

const toggleCheckValue = (valueId) => ({
    type: actionTypes.BROKER_TRANSFER_VALUES_TOGGLE_CHECK,
    payload: {
        valueId
    }
});

const setTitlesValue = (valueId, titles) => ({
    type: actionTypes.BROKER_TRANSFER_VALUES_SET_TITLES,
    payload: {
        valueId,
        titles
    }
});

const doTransferValues = () => (dispatch, getState) => {

    const callback = (dispatch, getState, dataToken) => {
        const immTransferValues = getState().brokerTransferValues;
        const immContractValues = getState().brokerContractValues;

        const contractFrom = immTransferValues.getIn(['steps', 0, 'accountIdFrom']);
        const contractTo = immTransferValues.getIn(['steps', 0, 'accountIdTo']);

        const immContractFrom = immTransferValues.getIn(['steps', 0, 'accountsFromOptions', contractFrom]);
        const immContractTo = immTransferValues.getIn(['steps', 0, 'accountsToOptions', contractTo]);

        const requestData = {
            query: {
                dataToken,
                contratos: {
                    contratoDestino: {
                      numerodecontrato: immContractTo.get('walletNumber'),
                      producto: immContractTo.get('productNumber')
                    },
                    contratoValores: {
                      numerodecontrato: immContractFrom.get('walletNumber'),
                      producto: immContractFrom.get('productNumber')
                    }
                }
            }
        };

        let requestUrlKey;


        if ( immTransferValues.getIn(['steps', 1, BROKER_TRANSFER_VALUES_TYPE_TOTAL, 'selected']) ) {
            requestUrlKey = 'totalTransferValues';
        }

        if ( immTransferValues.getIn(['steps', 1, BROKER_TRANSFER_VALUES_TYPE_PARTIAL, 'selected']) ) {
           requestUrlKey = 'partialTransferValues';

           const valueId = immTransferValues.getIn(['steps', 1, BROKER_TRANSFER_VALUES_TYPE_PARTIAL, 'id']);
           const immTitles = immTransferValues.getIn(['steps', 1, 'titles']);
           const immValue = immContractValues.getIn([immContractFrom.get('walletNumber'), 'byId', valueId])
           const titles = immTitles.get(valueId);

           Object.assign(requestData.query, {
                numTitulos: titles,
                codValor: immValue.get('valueCode'),
                codigoEmision: immValue.get('emisionCode')
           });
        }

        dispatch(transferValuesRequest());
        return APIPost(dispatch, apiURLBuilder.getURL(requestUrlKey) , requestData)
            .then(response => dispatch(transferValuesSuccess(response)))
            .catch(error => dispatch(transferValuesFailure(error)))
    };

    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    })
}

module.exports = {
    reset,
    setVisibleStep,
    validateStep,
    setWillCancel,
    setAccountFrom,
    setAccountTo,
    setAccountsFromOptions,
    setAccountsToOptions,
    toggleCheckValue,
    setTitlesValue,
    doTransferValues,
    setType,
    resetContractErrors
}
